export default __webpack_public_path__ + "b7e23df418cdec82558b960163a99a02.png";